module.exports = __webpack_public_path__ + "static/media/mosaic-logo.aaaf5280.svg";